/*
  <featured-product-grid>
  Behavior for sections/featured-product-grid.liquid: 
  
  - Varianten-Dropdown (Aktualisierung von Preis und Stückpreis) und „In den Warenkorb“. 
  - Die Listener sind direkt am Element angeordnet
  - Das Element erwartet:
      # select.ProductItem__VariantSelect with option data-* attributes (price, compare-at, unit price)
      # button[data-add-to-cart][data-variant-input="<id of select/hidden input>"]
*/

class FeaturedProductGrid extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('change', this.handleChange);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
    this.removeEventListener('click', this.handleClick);
  }

  handleChange(event) {
    const select = event.target.closest('.ProductItem__VariantSelect');
    if (!select) return;

    const productElement = select.closest('.unit__elem');
    const priceList = productElement?.querySelector('.ProductMeta__PriceList');
    const option = select.selectedOptions[0];
    if (!priceList || !option) return;

    this.updateUnitPrices(productElement, option);
    this.updatePriceList(priceList, option);
  }

  handleClick(event) {
    const button = event.target.closest('[data-add-to-cart]');
    if (button) this.addToCart(button);
  }

  /* Update the unit price (base price metafield and native unit price measurement) of a product */
  updateUnitPrices(productElement, option) {
    const basePrice = productElement.querySelector('.var_basicprice');
    if (basePrice) {
      basePrice.textContent = option.dataset.basePrice || '';
    }

    const unitPriceMeasurement = productElement.querySelector('.ProductMeta__UnitPriceMeasurement');
    if (!unitPriceMeasurement) return;

    const { unitPrice, unitReferenceValue, unitReferenceUnit } = option.dataset;
    unitPriceMeasurement.style.display = unitPrice ? 'block' : 'none';
    if (!unitPrice) return;

    unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').textContent = unitPrice;
    unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = unitReferenceUnit;

    const referenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
    if (referenceValue) {
      referenceValue.textContent = unitReferenceValue;
      referenceValue.hidden = unitReferenceValue === '1';
    }
  }

  updatePriceList(priceList, option) {
    const createPrice = (modifier, text) => {
      const span = document.createElement('span');
      span.className = `ProductMeta__Price Price ${modifier} Text--subdued u-h4 bold`;
      span.textContent = text;
      return span;
    };

    const compareAtPrice = option.dataset.compareAtPrice;
    if (compareAtPrice) {
      const wrapper = document.createElement('div');
      wrapper.className = 'priceFlex';
      wrapper.append(
        createPrice('Price--highlight', option.dataset.price),
        createPrice('Price--compareAt', compareAtPrice)
      );
      priceList.replaceChildren(wrapper);
    } else {
      priceList.replaceChildren(createPrice('', option.dataset.price));
    }
  }

  async addToCart(button) {
    const variantId = document.getElementById(button.dataset.variantInput)?.value;
    if (!variantId) {
      console.error('Add to cart failed: no variant selected.');
      return;
    }

    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || response.statusText);
      }

      document.querySelector('.cartiicon.Icon-Wrapper--clickable')?.click();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      button.disabled = false;
    }
  }
}

if (!customElements.get('featured-product-grid')) {
  customElements.define('featured-product-grid', FeaturedProductGrid);
}
